import type { ReactElement } from 'react'
import { motion, AnimatePresence } from "framer-motion";
import { FC } from "react";

// For the container component
interface StatePageContainerProps {
  children: React.ReactNode;
  id: string;
}


// Modify the container component to explicitly return ReactElement
export const StatePageContainer = ({children, id}: {children: React.ReactNode; id: string}): ReactElement => {
    return (
        <motion.div
          key={id}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 20 }}
          transition={{ duration: 0.3 }}
        >
          {children}
        </motion.div>
    )
}
